import { CardCreateExpense } from "@/components/Cards/Create/Expense"
import { Stepper } from "@/components/Stepper"
import Instruction from "@/pages/Topup/sections/Instruction"
import Status from "@/pages/Topup/sections/Status"
import { cn } from "@/utils"
import { DepositType, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom"
import { SelectPayment } from "../../Top-up/SelectPayment"
import { VerifyModal } from "./Expense/VerifyModal"
const STEPS = [
  { name_id: "create-step1", name: "Please choose what kind of card you want to create:", path: "" },
  { name_id: "create-step2", name: "Please complete the card order", path: "" },
]
export const CardsCreate = () => {
  const { verify_flags } = useStoreClient(selectUser)
  const { path } = useRouteMatch()
  const { pathname } = useLocation()
  const isExpensePage = /create\/?$/gi.test(pathname)
  const isInstructionOrStatus = pathname.includes("/create/instructions") || pathname.includes("/create/status/")
  return (
    <div className={cn("py-10", !isInstructionOrStatus && "bg-white")}>
      <div className="container max-w-[500px] flex flex-col items-center center">
        <span className="main-form-cards_title">
          <FormattedMessage id="order-card" />
        </span>
        <Stepper className="!max-w-[500px] my-[30px]" steps={STEPS} currentStep={isExpensePage ? 1 : 2} />
      </div>
      <main>
        <div className="max-w-1530 px-4">
          {(verify_flags as number) < 126 ? (
            <VerifyModal />
          ) : (
            <Switch>
              <Route path={path} exact component={CardCreateExpense} />
              <Route path={`${path}/select-payment`}>
                <SelectPayment isOrder />
              </Route>
              <Route path={`${path}/instructions`}>
                <Instruction depositType={DepositType.Card} isOrder />
              </Route>
              <Route path={`${path}/status/:token`}>
                <Status depositType={DepositType.Card} isOrder />
              </Route>
            </Switch>
          )}
        </div>
      </main>
    </div>
  )
}
